const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Africa/Casablanca', year: 'numeric', month: '2-digit', day: '2-digit',
});

export const businessDate = (instant = new Date()) => {
  const parts = Object.fromEntries(formatter.formatToParts(instant).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const posSaleDates = (source, instant = new Date()) => {
  const today = businessDate(instant);
  if (source?.id && (source.status ?? source.statut) === 'LIVRE') {
    return { dateOperation: source.dateOperation || today, dateLivraison: source.dateLivraison || source.dateOperation || today };
  }
  return { dateOperation: today, dateLivraison: today };
};
